import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import SplitText from "gsap/SplitText";

gsap.registerPlugin(SplitText, ScrollTrigger);
const segmenter = new Intl.Segmenter("ja", { granularity: "word" });

const preventScroll = (e) => {
  if (e.target === document.body) {
    e.preventDefault();
  }
};

export function disableBodyScroll() {
  document.body.style.overflow = "hidden";
  document.body.addEventListener("wheel", preventScroll, { passive: false });
  document.body.addEventListener("touchmove", preventScroll, {
    passive: false,
  });
}

export function enableBodyScroll() {
  document.body.style.overflow = "";
  document.body.removeEventListener("wheel", preventScroll, { passive: false });
  document.body.removeEventListener("touchmove", preventScroll, {
    passive: false,
  });
}
export const initInfiniteSliders = () => {
  const track = document.querySelector(".track");
  if (!track) return;
  const slides = [...track.children];

  slides.forEach((slide) => {
    track.appendChild(slide.cloneNode(true));
  });

  const trackWidth = track.scrollWidth / 2;
  const duration = 40000;
  const fps = 60;
  const frameTime = 1000 / fps;
  const totalFrames = duration / frameTime;
  const distancePerFrame = trackWidth / totalFrames;

  let pos = 0;

  function scrollLoop() {
    pos -= distancePerFrame;

    if (Math.abs(pos) >= trackWidth) {
      pos += trackWidth;
    }

    track.style.transform = `translate3d(${pos}px, 0, 0)`;
    requestAnimationFrame(scrollLoop);
  }

  track.style.willChange = "transform";
  scrollLoop();
};

function animateRevealText(el) {
  let split;
  let tl;
  let hasStarted = false;

  const delayAttr = el.getAttribute("delay") || el.dataset.delay;
  const delay = parseFloat(delayAttr);
  const finalDelay = isNaN(delay) ? 0.2 : delay;

  const infiniteAttr = el.getAttribute("infinite") || el.dataset.infinite;
  const isInfinite = infiniteAttr === "true" || infiniteAttr === "";

  const trigger = ScrollTrigger.create({
    trigger: el,
    start: "top 105%",
    end: "bottom 15%",
    toggleActions: isInfinite ? "play none none reset" : "play none none none",
    immediateRender: false,
    onEnter: (self) => {
      if (self.direction === 1) {
        if (!hasStarted) {
          document.fonts.ready.then(() => {
            split = SplitText.create(el, {
              type: "words",
              wordsClass: "reveal-word",
              autoSplit: true,
              prepareText: (text) => {
                return [...segmenter.segment(text)]
                  .map((s) => s.segment)
                  .join(String.fromCharCode(8204));
              },
              wordDelimiter: { delimiter: /\u200c/ },
            });

            const words = split.words;

            gsap.set(words, {
              opacity: 0,
              y: 0,
              force3D: true,
              willChange: "opacity",
              display: "inline-block",
            });

            tl = gsap.timeline({
              defaults: { ease: "power1.out", duration: 0.35, force3D: true },
            });

            tl.to(words, {
              opacity: 1,
              stagger: 0.06,
              delay: finalDelay,
            });

            tl.play();
            hasStarted = true;
          });
        } else if (isInfinite) {
          tl.restart();
        }
      }
    },
    onEnterBack: (self) => {
      if (self.direction === -1) {
        if (isInfinite && hasStarted) {
          tl.restart();
        }
      }
    },
    onLeave: () => {
      if (isInfinite && hasStarted) {
        gsap.set(split.words, { opacity: 0, force3D: true });
        tl.pause(0);
      }
    },
    onLeaveBack: () => {
      if (isInfinite && hasStarted) {
        gsap.set(split.words, { opacity: 0, force3D: true });
        tl.pause(0);
      }
    },
  });
}

export function observeRevealText() {
  const options = {
    root: null,
    rootMargin: "0px",
    threshold: 0.15,
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        animateRevealText(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, options);

  document.querySelectorAll(".reveal-text").forEach((el) => {
    observer.observe(el);
  });
}

export function wrapCharsWithSpan() {
  document.querySelectorAll(".blur-text").forEach((el) => {
    const fragment = document.createDocumentFragment();
    let charIndex = 0;

    el.childNodes.forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        [...node.textContent].forEach((char) => {
          const span = document.createElement("span");
          span.textContent = char === " " ? "\u00A0" : char;
          span.style.animationDelay = `${charIndex * 0.05}s`;
          fragment.appendChild(span);
          charIndex++;
        });
      } else {
        fragment.appendChild(node.cloneNode(true));
      }
    });

    el.textContent = "";
    el.appendChild(fragment);
  });
}
